import About from '../../modules/About/About';
import Blogs from '../../modules/Blogs/Blogs';
import Careers from '../../modules/Careers/Careers';
import Demo from '../../modules/Demo/Demo';
import HomePage from '../../modules/HomePage/HomePage';
import Products from '../../modules/Products/Products';
import Research from '../../modules/Research/Research';

function HomePageLayout() {
  return (
    <div>
      <HomePage />
      <About />
      <Products />
      <Research />
      <Careers />
      <Blogs />
      <Demo />
    </div>
  );
}

export default HomePageLayout;

